export const orderStatusObj = {
    CREATED: "CREATED",
    SHIPPING: "Shipped",
    WAITINGFORAPPROVAL: "Pending quotation approval",
    ORDERINPROCESS: "Order in process",
    HALFPAYMENTRECIEVED: "HALFPAYMENTRECIEVED",
    COMPLETEPAYMENTRECIEVED: "COMPLETEPAYMENTRECIEVED",
    REJECTED: "Rejected",
    COMPLETED: "COMPLETED",
}